const systemFontFamilies = [
	{
		label: 'Common',
		title: 'Common',
		options: [
			{
				label: 'Source Sans Pro, sans-serif',
				value: 'Source Sans Pro, sans-serif',
				title: 'Source Sans Pro, sans-serif'
			},
			{
				label: 'Arial, sans-serif',
				value: 'Arial, sans-serif',
				title: 'Arial, sans-serif'
			},
			{
				label: 'Times New Roman, serif',
				value: 'Times New Roman, serif',
				title: 'Times New Roman, serif'
			},
			{
				label: 'Courier New, monospace',
				value: 'Courier New, monospace',
				title: 'Courier New, monospace'
			},
			{
				label: 'Verdana, sans-serif',
				value: 'Verdana, sans-serif',
				title: 'Verdana, sans-serif'
			},
			{
				label: 'Georgia, serif',
				value: 'Georgia, serif',
				title: 'Georgia, serif'
			},
			{
				label: 'Trebuchet MS, sans-serif',
				value: 'Trebuchet MS, sans-serif',
				title: 'Trebuchet MS, sans-serif'
			},
			{
				label: 'Arial Black, sans-serif',
				value: 'Arial Black, sans-serif',
				title: 'Arial Black, sans-serif'
			},
			{
				label: 'Impact, fantasy',
				value: 'Impact, fantasy',
				title: 'Impact, fantasy'
			}
		]
	},
	{
		label: 'Windows',
		title: 'Windows',
		options: [
			{
				label: 'Arial Narrow, sans-serif',
				value: 'Arial Narrow, sans-serif',
				title: 'Arial Narrow, sans-serif'
			},
			{
				label: 'Book Antiqua, serif',
				value: 'Book Antiqua, serif',
				title: 'Book Antiqua, serif'
			},
			{
				label: 'Brush Script MT, cursive',
				value: 'Brush Script MT, cursive',
				title: 'Brush Script MT, cursive'
			},
			{
				label: 'Century Gothic, sans-serif',
				value: 'Century Gothic, sans-serif',
				title: 'Century Gothic, sans-serif'
			},
			{
				label: 'Comic Sans MS, cursive',
				value: 'Comic Sans MS, cursive',
				title: 'Comic Sans MS, cursive'
			},
			{
				label: 'Lucida Console, monospace',
				value: 'Lucida Console, monospace',
				title: 'Lucida Console, monospace'
			},
			{
				label: 'Lucida Sans Unicode, sans-serif',
				value: 'Lucida Sans Unicode, sans-serif',
				title: 'Lucida Sans Unicode, sans-serif'
			},
			{
				label: 'Monaco, monospace',
				value: 'Monaco, monospace',
				title: 'Monaco, monospace'
			},
			{
				label: 'Tahoma, sans-serif',
				value: 'Tahoma, sans-serif',
				title: 'Tahoma, sans-serif'
			},
			{
				label: 'Monotype Corsiva, cursive',
				value: 'Monotype Corsiva, cursive',
				title: 'Monotype Corsiva, cursive'
			}
		]
	},
	{
		label: 'macOS/iOS',
		title: 'macOS/iOS',
		options: [
			{
				label: 'Helvetica, sans-serif',
				value: 'Helvetica, sans-serif',
				title: 'Helvetica, sans-serif'
			},
			{
				label: 'Times, serif',
				value: 'Times, serif',
				title: 'Times, serif'
			},
			{
				label: 'Courier, monospace',
				value: 'Courier, monospace',
				title: 'Courier, monospace'
			},
			{
				label: 'Palatino, serif',
				value: 'Palatino, serif',
				title: 'Palatino, serif'
			},
			{
				label: 'Garamond, serif',
				value: 'Garamond, serif',
				title: 'Garamond, serif'
			},
			{
				label: 'Bookman, serif',
				value: 'Bookman, serif',
				title: 'Bookman, serif'
			},
			{
				label: 'Apple Chancery, cursive',
				value: 'Apple Chancery, cursive',
				title: 'Apple Chancery, cursive'
			}
		]
	}
];

export default systemFontFamilies;
